import { theme } from '../../../../../../../Assets/Styles/theme'

const style = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    padding: '20px 0 30px',
  },
  topButtonWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  buttonsWrapper: {
    display: 'flex',
  },
  button: {
    height: '32px',
    textTransform: 'none',
    marginRight: '10px',
    fontWeight: '600',
    borderRadius: '16px',
    padding: '20px',
    float: 'right',
  },
  createSequenceButtonWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  createSequenceButton: {
    backgroundColor: `${theme.colors.primary}`,
    color: 'white',
    '&:hover': {
      backgroundColor: `${theme.colors.primary}`,
    },
  },
  backButton: {
    marginRight: '14px',
  },
  label: {
    fontSize: '18px',
  },
  warn: {
    marginTop: '10px',
    color: 'red',
    marginLeft: '2px',
  },
}
export default style
